import { useFormContext, useFormState } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import FormInputAsycnPaginate from "../../shared/FormInputAsycnPaginate";
import FormInputText from "../../shared/FormInputText";
import FormSelect from "../../shared/FormSelect";
import FormCheckbox from "../../shared/FormCheckbox";
import FormInputNumber from "../../shared/FormInputNumber";
import { loadTaxEntities } from "../../../utils/optionLoaderUtils";
import FormDate from "../../shared/FormDate";
import { getAccountTypes } from '../../../utils/apiUtils';
import { ACTIONS } from "../../../utils/constants";

const step = 1;
const TopAccountStepOne = ({ activeStep }) => {
    const { control, register, setValue, getValues } = useFormContext();
    const { errors } = useFormState({ control });

    const { data: accountTypes } = useQuery({
        queryKey: ['getAccountTypes'],
        queryFn: () => getAccountTypes(),
        select: (data) => data?.rows.filter(row => row.accountTypeCode.includes('AT')).map((entry) => {
            return { value: entry.accountTypeCode, label: entry.accountTypeDesc }})
    });

    if (activeStep !== step) return null;

    const action = getValues('action');

    return (
        <div style={{ width: "50%" }}>
            {action === ACTIONS.AMEND && 
                <FormDate label={'As of date'} name={'asOfDate'} control={control} errors={errors} />
            }
            <FormCheckbox
                label={'Update All Versions'}
                name={'updateAllVersions'}
                control={control}
            />
            <br />
            <FormInputAsycnPaginate
                label={"Tax Entity"}
                name={"taxEntity"}
                control={control}
                loadOptions={loadTaxEntities}
                errors={errors}
                placeholder="Select a tax entity"
            />
            <FormInputText label={'Account Name'} register={register} name={'accountName'} errors={errors} placeholder="Account name" />
            <FormInputText label={'Account HCC ID'} register={register} name={'accountHccId'} errors={errors} placeholder="HCC ID" />
            <FormSelect
                label={'Account Type'}
                name={'accountType'}
                control={control}
                options={accountTypes}
                errors={errors}
                placeholder="Account type"
            />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '2rem' }}>
                <div className="form-input">
                    <label>Effective Date</label>
                    <input
                        {...register("effectiveDate")}
                        name="effectiveDate"
                        style={{ padding: ".8rem", height: '48px' }}
                        type={"date"}
                        placeholder="Effective date"
                        autoComplete="off"
                    />
                    {errors.effectiveDate && (
                        <p className="danger" style={{ color: "var(--red)", paddingTop: ".4rem" }}>
                            {errors.effectiveDate.message}
                        </p>
                    )}
                </div>
                <FormInputNumber name={"renewalInterval"} label={`Renewal Interval (Months)`} errors={errors} register={register} />
            </div>
            <FormCheckbox
                label={'Subscriptions Allowed'}
                name={'subscriptionsAllowed'}
                control={control}
            />
        </div>
    );
};

export default TopAccountStepOne;
